import { inject, Injectable } from '@angular/core';
import { Observable }         from 'rxjs';
import { UserService }        from '../../api/user/user.service';

export enum ActionLog {
  MFA_RESET = 'MFA_RESET',
  MFA_SETUP_SUCCESS = 'MFA_SETUP_SUCCESS'
}

@Injectable({
  providedIn: 'root'
})
export class LoggingUtils {
  private userService = inject(UserService);

  logUserAction(actionLog: string, value: string): Observable<ArrayBuffer> {
    return this.userService.logUserAction(actionLog, value);
  }
}
